import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    fromDate: 'From {date}',
    fromDateToDate: 'From {start} until {end}',
    onDate: 'On {date}',
    schedule: 'Schedule',
    scheduleDescription: 'Send later, repeat.',
    settings: 'Settings',
  },
  fr: {
    fromDate: 'À partir du {date}',
    fromDateToDate: 'À partir du {start} jusqu’au {end}',
    onDate: 'Le {date}',
    schedule: 'Programmer',
    scheduleDescription: 'Envoyer plus tard, répéter.',
    settings: 'Paramètres',
  },
} as const);
